import ReactModal from "react-modal";
import styled from "styled-components";

export const Container = styled.form`
  .popup-title {
    width: 100%;
    text-align: center;

    h1 {
      font-weight: 600;
    }
  }

  label { 
    font-size: 14px; 
  }

  .add-ingredient-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
`;

export const StyledReactModal = styled(ReactModal)`
  position: absolute;
  top: 50%;
  left: 50%;
  right: auto;
  bottom: auto;
  transform: translate(-50%, -50%);
  border-radius: 3rem;
  padding: 1rem;

  background: white;
  overflow: auto;
  outline: none;

  @media (max-width: 425px) {
    width: 90%;
    padding: 1.5rem;
  }
`;